const SubirIcon = () => {
  return (
    <svg
      width="28"
      height="23"
      viewBox="0 0 28 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="0.5"
        y="0.5"
        width="23"
        height="18"
        rx="1.5"
        fill="#FDFDFD"
        stroke="#FF6600"
      />
      <rect
        x="4.5"
        y="4.5"
        width="23"
        height="18"
        rx="1.5"
        fill="#FDFDFD"
        stroke="#FF6600"
      />
    </svg>
  );
};

export default SubirIcon;
